export enum OrderClassEnum {
	BRACKET = 'bracket',
	OCO = 'oco',
	OTO = 'oto',
}
